import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  getMachineRequestAPI,
  createRequest,
  editRequest,
  deleteRequest,
  getMachineRequest,
  getSec,
} from '../../services/mm/apiController';
import { useSelector, useDispatch } from 'react-redux';
import { setBreadCrumb, removeAllBreadCrumb } from '../../store/reducers/menu_reducer';
import { loggedInUser, factoryId } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY, MACHINE_STATUS } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from '../vm/components/icons';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import FactoryDropdown from '../vm/FactoryDropdown';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';

const MachineRequestController = (props) => {
  const formFields = {
    model: '',
    section: '',
    requestedBy: '',
    initiatedBy: '',
    requestedDate: '',
    reason: '',
    file_1: null,
    file1: '',
    file_2: null,
    file2: '',
    factoryId: localStorage.factoryId,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const dispatch = useDispatch();

  const search = useLocation().search;
  const status__ = new URLSearchParams(search).get('status');
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  let user = useSelector(loggedInUser);
  const [modelName, setModelName] = useState('');
  const [status, setStatus] = useState(status__ ?? '');
  const [machineRequests, setMachineRequests] = useState([]);
  const [sections, setSections] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [machineForm, setMachineForm] = useState(formFields);
  const [validated, setValidated] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const [idToDeleted, setIdToDeleted] = useState('');
  const [invalidFileType, setInvalidFileType] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const factoryId_ = useSelector(factoryId);

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);
    setValidated(false);
    setMachineForm(formFields);
  };

  const handleShowConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const getMachineRequests = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        name: modelName || '',
        status: status || '',
      };
      const ftId = await localStorage.getItem('factoryId');
      console.log(ftId);
      if (ftId) {
        condition['factoryId'] = ftId;
      } else {
        return {};
      }
      const machineRequest = await getMachineRequestAPI(offset, limit, condition);
      return {
        data: (machineRequest && machineRequest.data.rows) || [],
        totalRecords: (machineRequest && machineRequest.data && machineRequest.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setMachineForm({ ...machineForm, [name]: value });
  };

  const handleMachineTypeSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setMachineForm({ ...machineForm, [name]: value });
  };

  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setMachineForm({ ...machineForm, file_1: null, file1: '' });
      setInvalidFileType(true);
      toast.error('Please select a valid file type.');
    } else {
      setInvalidFileType(false);
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setMachineForm({ ...machineForm, file1: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error.');
          }
        })
        .catch((err) => {
          // Handle error
          toast.error('Error');
        });
    }
  };

  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setMachineForm({ ...machineForm, file_2: null, file2: '' });
      setInvalidFileType(true);
      toast.error('Please select a valid file type.');
    } else {
      setInvalidFileType(false);
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setMachineForm({ ...machineForm, file2: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const editRequestNew = (event, id, factoryId) => {
    event.preventDefault();
    localStorage.setItem('factoryId', factoryId);
    const getSingleMachine = async () => {
      const data = await getMachineRequest(id);
      data.data.requestedDate = moment(data.requestedDate).format('YYYY-MM-DD');
      await setMachineForm(data.data);
    };
    getSingleMachine();
    setShow(true);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteMachine = async () => {
      const data = await deleteRequest(id);
      toast.success(data.data);
      setShowConfirmModel(false);
      getRequests();
    };
    deleteMachine();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (invalidFileType) {
      toast.error('Please select a valid file.', { autoClose: 2000 });
      return;
    }

    if (machineForm.id) {
      try {
        setIsButtonDisabled(false);
        if (!machineForm.model) toast.error('Machine Name must be provided');
        else if (!machineForm.section) toast.error('Section must be provided');
        else if (!machineForm.requestedBy) toast.error('Requested By must be provided');
        else if (!machineForm.initiatedBy) toast.error('Initiated By must be provided');
        else if (!machineForm.requestedDate) toast.error('Requested Date must be provided');
        else if (!machineForm.reason) toast.error('Reason must be provided');
        else {
          await editRequest(machineForm.uuid, machineForm);
          toast.success('Machine Request updated successfully');
          setShow(false);
          getRequests();
        }
      } catch (err) {
        toast.error(err.message, { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        if (!machineForm.model) toast.error('Machine Name must be provided');
        else if (!machineForm.section) toast.error('Section must be provided');
        else if (!machineForm.requestedBy) toast.error('Requested By must be provided');
        else if (!machineForm.initiatedBy) toast.error('Initiated By must be provided');
        else if (!machineForm.requestedDate) toast.error('Requested Date must be provided');
        else if (!machineForm.reason) toast.error('Reason must be provided');
        else {
          await createRequest(machineForm);
          toast.success('Machine Request added successfully');
          setShow(false);
          getRequests();
        }
      } catch (err) {
        toast.error(err.message, { autoClose: 2000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  async function getRequests() {
    const data = await getMachineRequests(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(data.totalRecords);
    setMachineRequests(data.data);
  }

  async function getSections() {
    const data = await getSec(factoryId_);
    setSections(data.data);
  }

  useEffect(() => {
    getRequests();
  }, [currentPage]);

  useEffect(() => {
    getSections();
  }, [factoryId_]);

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getRequests();
      }
    },
    [modelName, status],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    dispatch(removeAllBreadCrumb());
    dispatch(
      setBreadCrumb({
        label: 'Machine Request List',
        value: '/machine-requests',
      })
    );
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/mm/machine-requests">Machine Request List</Link>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getRequests} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Model Name</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Model Name"
                aria-describedby="emailHelp"
                value={modelName}
                onChange={(e) => {
                  setModelName(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Status</label>
              <Form.Select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                className="all-select-custom"
                aria-label="Default select example"
              >
                <option value="" disabled hidden>
                  Select Status
                </option>
                <option value={MACHINE_STATUS.INITIATED}>{MACHINE_STATUS.INITIATED}</option>
                <option value={MACHINE_STATUS.APPROVED}>{MACHINE_STATUS.APPROVED}</option>
                <option value={MACHINE_STATUS.INSTALLED}>{MACHINE_STATUS.INSTALLED}</option>
              </Form.Select>
            </div>
            <div className="form-group col-md-5 col-lg-5">
              <div className="btn-wrapper justify-content-start cmt-3">
                <button
                  type="button"
                  className="btn app-btn-default"
                  onClick={(e) => {
                    setModelName('');
                    setStatus('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          {factoryId_ ? (
            <>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                New Machine Requests | {totalRecords ?? 0}
              </h4>
              <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                New Request
              </button>
            </>
          ) : (
            <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
              Please Select a Factory
            </h4>
          )}
        </div>
        {factoryId_ && totalRecords > 0 ? (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Machine name</th>
                      <th>Section</th>
                      <th>Requested By</th>
                      <th>Initiated By</th>
                      <th>Requested Date</th>
                      <th>Reason</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {machineRequests?.map((request, index) => {
                      return (
                        <tr key={request.uuid}>
                          <td>{request.model}</td>
                          <td>{request.section}</td>
                          <td>{request.requestedBy}</td>
                          <td>{request.initiatedBy}</td>
                          <td>{formatDate(request.requestedDate)}</td>
                          <td>{request.reason}</td>
                          <td>{request.status}</td>
                          <td className="actions">
                            <div className="d-flex">
                              <div className="view">
                                <button
                                  onClick={(event) => {
                                    localStorage.setItem('factoryId', request?.factoryId);
                                  }}
                                  style={{ border: 'none', backgroundColor: 'white' }}
                                >
                                  <Link to={`/mm/machine-requests/${request.id}`}>
                                    <ViewIcon />
                                  </Link>
                                </button>
                              </div>
                              <div className="edit">
                                <button style={{ border: 'none', backgroundColor: 'white' }}>
                                  <span className="edit-icon" onClick={(event) => editRequestNew(event, request.id, request?.factoryId)}>
                                    <EditIcon />
                                  </span>
                                </button>
                              </div>
                              <div className="remove">
                                <button style={{ border: 'none', backgroundColor: 'white' }}>
                                  <Link className="delete" onClick={(e) => handleShowConfirmModal(e, request.uuid)} to="/">
                                    <DeleteIcon />
                                  </Link>
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {factoryId_ ? (
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                  No Data Available
                </h4>
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{machineForm.id === undefined ? 'Add Machine Request' : 'Edit Machine Request'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="model"
                    value={machineForm.model}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    aria-required="false"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Section">
                  <Form.Select
                    value={machineForm.section}
                    onChange={handleMachineTypeSelect}
                    name="section"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Section</option>
                    {Object.keys(sections).map((key) => (
                      <option key={key} value={key.value}>
                        {sections[key].value}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Requested By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedBy"
                    value={machineForm.requestedBy}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="initiatedBy"
                    value={machineForm.initiatedBy}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Requested Date" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedDate"
                    value={machineForm.requestedDate}
                    onChange={handleChange}
                    type="date"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={8}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    className="input"
                    name="reason"
                    value={machineForm.reason}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file1" aria-required="false" />
                  {machineForm.file1 !== null ? <p className="mb-0">{machineForm.file1}</p> : ''}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file2" aria-required="false" />
                  {machineForm.file2 !== null ? <p className="mb-0">{machineForm.file2}</p> : ''}
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
              {!Object.keys(machineForm).includes('id') ? 'Add Request' : 'Update Request'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Machine Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default MachineRequestController;
